<template>
    <div :id="id"></div>
</template>
<script>
import * as d3 from '../../static/js/d3.js';
export default {
    name: "d3chart",
    props:{
        id:{
            type:String
        },
        'ds':{
            type: Array | Object
        },
        updateDs:{
            type: Array | Object
        },
        circleColor:{  //圆点的颜色
            type: Array | Object,
            default:function(){
                return d3.schemeCategory20
            }
        },
        circleSize:{  //圆点的大小
            type: Array | Object,
            default:function(){
                return [15,10]
            }
        },
        textColor:{  //文字颜色
            type: String,
            default:function(){
                return '#fff'
            }
        },
        callback:{
            type:Function
        }
    },
    data() {
        return {
            vis :[],

            simulation:'',
            nodes:'',  //点
            text:'',   //文字
            link:'',   //线
            linetext:'',   //关系文字
            curNode:{},
            isActive:[] //已经点击过的点
        }
    },

    mounted() {
      let that = this
        that.$nextTick(()=> {

        })
    },
    watch: {
        'ds': function (n, o) {
            this.loadD3();
        },
        'updateDs': function (n, o) {
            let that = this,nodeArr = [];
            nodeArr = that.updateDs.nodes;
            let oldL = that.ds.nodes.length;
            if(nodeArr.length > 0){
                that.ds.nodes = that.unique(that.ds.nodes,nodeArr)
            }

            let newL = that.ds.nodes.length
            if(newL != oldL){
                that.updateDs.links.forEach(function (e) {
                    if(typeof e.source!="number"&&typeof e.target!="number"){
                        var sourceNode = that.ds.nodes.filter(function (n) {
                                    return n.name === e.source;
                                })[0],
                                targetNode = that.ds.nodes.filter(function (n) {
                                    return n.name === e.target;
                                })[0];
                        e.source = sourceNode;
                        e.target = targetNode;
                    }
                });
            }else{
                that.updateDs.links = [];

            }
            that.update();
        }
    },
    // updated() {
    //     this.update();
    // },
    methods: {
        unique(arr,arr1) {
            var result = [];
            let add = arr1.filter(obj=>!arr.some(obj1=>obj1.name==obj.name))

            if(add.length>0){
                result = arr.concat(add)
            }else{
                result = arr
            }
            return result
        },
        loadD3(){
            let that = this;
            let svg = d3.select("#"+that.id);
            svg.selectAll("*").remove();
            let getWidth = svg.attr("width");
            if(that.ds == ''){
                return
            }
            if(getWidth =='100%'){
                getWidth = document.getElementById(that.id).offsetWidth
            }
            function GroupExplorer(wrapper){
                var defaultConfig={
                    data:that.ds,
                    width:getWidth,
                    height:svg.attr("height"),
                    distance:200
                };
                defaultConfig.data.links.forEach(function (e) {
                    if(typeof e.source!="number"&&typeof e.target!="number"){
                        var sourceNode = defaultConfig.data.nodes.filter(function (n) {
                                    return n.name === e.source;
                                })[0],
                                targetNode = defaultConfig.data.nodes.filter(function (n) {
                                    return n.name === e.target;
                                })[0];
                        e.source = sourceNode;
                        e.target = targetNode;
                    }
                });
                var highlighted=null,dependsNode=[],dependsLinkAndText=[];

                var zoom = d3.zoom()
                        .scaleExtent([0.2,10])
                        .on("zoom",function(){
                            zoomed();
                        });

                that.vis = d3.select(wrapper).append("svg:svg")
                        .attr("width", defaultConfig.width)
                        .attr("height", defaultConfig.height)
                        .call(zoom).on("click.zoom", null);

                let vis1 = that.vis.append('g').attr('class','all')
                        .attr("width", defaultConfig.width)
                        .attr("height", defaultConfig.height)
                let vis2 = that.vis.append('g').attr('class','allCircle')
                        .attr("width", defaultConfig.width)
                        .attr("height", defaultConfig.height)

                that.simulation = d3.forceSimulation()
                        .nodes(defaultConfig.data.nodes)
                        .force("link", d3.forceLink(defaultConfig.data.links).distance(defaultConfig.distance))
                        //.force("charge", d3.forceManyBody())
                        .force("center", d3.forceCenter(defaultConfig.width / 2, defaultConfig.height / 2))
                        .force("charge",d3.forceManyBody())
                        .force("collide",d3.forceCollide(90).strength(0.05).iterations(2))



                vis1.append("svg:defs").selectAll("marker")
                        .data(["end"])
                        .enter().append("svg:marker")
                        .attr("id","arrow"+that.circleSize[1])
                        .attr('class','arrow')
                        .attr("viewBox", "0 -5 10 10")
                        .attr("refX", function(d,i) {
							return that.circleSize[1]*2 + 20/that.circleSize[1];
						})
                        .attr("refY", 0)
                        .attr("markerWidth", 9)
                        .attr("markerHeight", 16)
                        .attr("markerUnits","userSpaceOnUse")
                        .attr("orient", "auto")
                        .append("svg:path")
                        .attr("d", "M0,-5L10,0L0,5")
                        .attr('fill','#ddd');

                that.link = vis1.selectAll("line.link")
                        .data(defaultConfig.data.links)
                        .enter().append("svg:line")
                        .attr("class", "link")
                        .attr('stroke-width',1)
                        .attr("marker-end","url(#arrow"+that.circleSize[1]+")")
                        .attr('stroke','#bbb')


                var nodeDrag = d3.drag()
                        .on("start", that.dragstart)
                        .on("drag", that.dragmove)
                        .on("end", that.dragend);


                that.nodes = vis2.selectAll("circle")
                        .data(defaultConfig.data.nodes)
                        .enter().append("svg:circle")
                        .attr("class", "circle")
                        //.attr("xlink:href", "images/mobile.png")
                        .attr("x", "-15px")
                        .attr("y", "-15px")
                        .attr("width", "30px")
                        .attr("height","30px")
						.attr('r',function(d,i){
                             let curR = (i==0) ? that.circleSize[0] : that.circleSize[1]
                             return curR;
                        })
						.attr("fill", function(d,i) {
                            let len = that.circleColor.length;
							return that.circleColor[i%len];
						})
                        .call(nodeDrag)
                        .on('mouseover', function(d) {
                            if (that.nodes.mouseoutTimeout) {
                                clearTimeout(that.nodes.mouseoutTimeout);
                                that.nodes.mouseoutTimeout = null;
                            }
                        })
                        .on('mouseout', function() {
                            if (that.nodes.mouseoutTimeout) {
                                clearTimeout(that.nodes.mouseoutTimeout);
                                that.nodes.mouseoutTimeout = null;
                            }
                        })
                        .on('click',function(d){
                            if(!d3.event.defaultPrevented){
                                //that.highlightObject(d);
                                that.curNode = d;
                                that.$emit('entityFatherMethod',d.name,d.id);
                            }
                            d3.event.stopPropagation();
                        });
                    //    svg.on('click',function(){
                    //         dependsNode=dependsLinkAndText=[];
                    //         _this.highlightObject(null);
                    //     });
                 defaultConfig.data.nodes[0].fx = defaultConfig.width / 2
                defaultConfig.data.nodes[0].fy = defaultConfig.height / 2
                that.text = vis1.selectAll("text")
                        .data(defaultConfig.data.nodes)
                        .enter().append("svg:text")
                        .attr("class", "nodetext")
                        .attr("dy", "30px")
                        .attr('text-anchor','middle')
                        .attr('fill',that.textColor)
                        .text(function(d) { return d.name })

                that.linetext=vis1.selectAll('.linetext')
                        .data(defaultConfig.data.links)
                        .enter()
                        .append("text")
                        .attr("class", "linetext")
                        .text(function (d) {
                            return d.relation
                        })
                        .attr('fill','#aaa')
                       // .call(d3.drag());

                var zoomed=function(){
                    vis1.attr("transform", d3.event.transform);
                    vis2.attr("transform", d3.event.transform);
                };
                that.simulation.on("tick", that.draw).alpha(0.2).alphaTarget(0.1).alphaDecay(0);

            }
            GroupExplorer("#"+that.id);
        },
        dragstart(d, i) {
            let that = this;
            // that.simulation.stop();
            // d3.event.sourceEvent.stopPropagation();
            if (!d3.event.active) that.simulation.alphaTarget(0.3).restart();
            d.fx = d.x;
            d.fy = d.y;
        },
        dragmove(d, i){
            let that = this;
            d.fx = d3.event.x;
            d.fy = d3.event.y;
            // d.px += d3.event.dx;
            //     d.py += d3.event.dy;
            //     d.x += d3.event.dx;
            //     d.y += d3.event.dy;
            //     that.draw();
        },
        dragend(d, i) {
            let that = this;
            //if (!d3.event.active) that.simulation.alphaTarget(0);
            // d.fx = null;
            // d.fy = null;
            //that.simulation.stop();
            //d3.event.sourceEvent.stopPropagation();
            // d3.event.subject.fx = null;
            // d3.event.subject.fy = null;
            // //that.simulation.restart();
            //that.draw();
        },
        draw(){
            let that = this;
            if(that.simulation.alpha()<=0.8){
                that.simulation.alpha(0.81)
            }
            that.link.attr("x1", function(d) { return d.source.x; })
                    .attr("y1", function(d) { return d.source.y; })
                    .attr("x2", function(d) { return d.target.x})
                    .attr("y2", function(d) { return d.target.y;});
            that.linetext.attr("x",function(d){ return (d.source.x + d.target.x) / 2})
                    .attr("y",function(d){ return (d.source.y + d.target.y) / 2});
            that.text.attr("x", function(d){ return d.x; })
                    .attr("y", function(d){ return d.y; });
            that.nodes.attr("transform", function(d) { return "translate(" + d.x + "," + d.y + ")"; });
        },
        highlightObject(obj,){
            let that = this;
            if (obj) {
                let objIndex = obj.index;
                let dependsNode = [];
                let dependsLinkAndText = [];
                dependsNode=dependsNode.concat([objIndex]);
                dependsLinkAndText=dependsLinkAndText.concat([objIndex]);
                that.ds.links.forEach(function(lkItem){
                    if(objIndex==lkItem['source']['index']){
                        dependsNode=dependsNode.concat([lkItem.target.index])
                    }else if(objIndex==lkItem['target']['index']){
                        if(that.isActive.length==0){
                            that.isActive.push(lkItem.source.index);
                        }
                        dependsNode=dependsNode.concat([lkItem.source.index])
                    }
                });
                if(that.isActive.length>0){
                    dependsNode = dependsNode.concat(that.isActive)
                }

                that.nodes.classed('inactive',function(d){
                    return (dependsNode.indexOf(d.index)==-1)
                });
                that.text.classed('inactive',function(d){
                    return (dependsNode.indexOf(d.index)==-1)
                });
                that.link.classed('inactive', function(d) {
                    return ((dependsLinkAndText.indexOf(d.source.index)==-1)&&(dependsLinkAndText.indexOf(d.target.index)==-1) && (that.isActive.indexOf(d.target.index)==-1))
                });

                that.linetext.classed('inactive',function(d){
                    return ((dependsLinkAndText.indexOf(d.source.index)==-1)&&(dependsLinkAndText.indexOf(d.target.index)==-1) && (that.isActive.indexOf(d.target.index)==-1))
                });
                that.isActive.push(objIndex);
            } else {
                that.nodes.classed('inactive', false);
                that.text.classed('inactive', false);
                that.link.classed('inactive', false);
                that.linetext.classed('inactive', false);
            }
        },
        update() {
            let that = this;
            let svg = d3.select("#"+that.id);
            if(that.updateDs.links.length>0){
                that.ds.links = that.ds.links.concat(that.updateDs.links)
            }

            that.link = that.link.data(that.ds.links, (d) => { return d.source.name + "-" + d.target.name; })
            that.link = that.link.enter()
                        .append("svg:line")
                        .attr("class", "link").attr('stroke-width',1)
                        .attr("marker-end","url(#arrow)")
                        .attr('stroke','#aaa')
                        .merge(that.link);
            that.nodes = that.nodes.data(that.ds.nodes)

             that.nodes =  that.nodes.enter()
                .append("svg:circle")
                .attr("class", "circle")
                .attr("x", "-15px")
                .attr("y", "-15px")
                .attr("width", "30px")
                .attr("height", "30px")
                .attr("r",that.circleSize[1])
                .attr("fill", function(d,i) {
                    let len = that.circleColor.length;
					return that.circleColor[i%len];
                })
                .merge(that.nodes).call(
                    d3.drag()
                    .on("start", that.dragstart)
                    .on("drag", that.dragmove)
                    .on("end", that.dragend)
                )
                .on('click',function(d){
                    if(!d3.event.defaultPrevented){
                        //that.highlightObject(d);
                        that.curNode = d;
                        that.$emit('entityFatherMethod',d.name,d.id);
                    }
                    d3.event.stopPropagation();
                });

            that.text =  that.text.data(that.ds.nodes)
            that.text =  that.text.enter().append("svg:text")
            .attr("class", "nodetext")
            .attr("dy", "30px")
            .attr('text-anchor','middle')
            .attr('fill',that.textColor)
            .text(function(d) { return d.name })
            .merge(that.text)

            that.linetext = that.linetext.data(that.ds.links);

            that.linetext = that.linetext.enter()
                .append("svg:text")
                .style("fill","#aaa")
                .attr("class", "linetext")
                .text(function (d) {
                    return d.relation
                })
                .merge(that.linetext);

            that.simulation.nodes(that.ds.nodes)
            that.simulation.force("link", d3.forceLink(that.ds.links).distance(200));
            that.simulation.on("tick", that.draw);
            that.simulation.alpha(0.3).restart();
        }
    }
}
</script>
<style lang="">
    .nodetext{pointer-events:none;font:12px sans-serif}
    .linetext{font-size:12px}
    .linetext.inactive,.link.inactive,.circle.inactive,.nodetext.inactive{opacity:0}
    .tooltip{font-family:"microsoft yahei",simsun;font-size:12px;width:170px;height:auto;z-index:2;position:absolute;background:#fff;opacity:.5;border-radius:5px;box-shadow:0 5px 10px rgba(0,0,0,.2)}
    .tooltip .title{color:#fff;padding:5px;font-size:14px;background-color:#337ab7;border-radius:5px 5px 0 0}
    .tooltip .detail-info{width:100%;border-collapse:collapse;border:1px solid #337ab7}
    .tooltip .detail-info td{padding:3px 5px;color:#666;vertical-align:middle}
    .tooltip .detail-info tr:nth-of-type(odd){background:#f9f9f9}
    .tooltip .detail-info td.td-label{color:#333;width:42px}
    .tooltip .detail-info td a{color:#666}
    .tooltip .cm-btn{cursor:pointer}
    .tooltip .cm-btn:hover{color:#337ab7}
    .add-node-dialog td{height:40px}
    .add-node-dialog .td-til{text-align:right;padding-right:10px;font-size:14px;color:#333}

</style>



// WEBPACK FOOTER //
// src/components/d3Chart.vue